import moment from 'moment';

export default function date(val) {
   const date = moment.utc(val).toDate();
   return date.toDateString();
}
